import React, { ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
  image: {
    src: string;
    alt: string;
  };
}

const AuthLayout = ({ children, image }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 md:p-8">
      <div className="w-full max-w-[1200px] flex flex-col lg:flex-row gap-8 lg:gap-16 items-center">
        <div className="flex-1 w-full">
          <div className="max-w-md mx-auto space-y-6 sm:space-y-8">
            {children}
          </div>
        </div>

        <div className="hidden lg:flex flex-1 items-center justify-center">
          <div className="w-full max-w-xl aspect-square rounded-2xl overflow-hidden shadow-2xl transform transition-all hover:scale-[1.02] hover:shadow-3xl duration-500 border border-white/20">
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;